import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;
    color: var(--white);

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.interests {
    display: grid;
    grid-template-columns: repeat(1, minmax(140px, 200px));
    padding: 0;
    margin: 10px 0px 20px 20px;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      background: transparent;
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const interests = ['Gen AI', 'Distributed Systems', 'Blockchain', 'Functional Programming'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! My name is Sanket and I enjoy building awesome software that solve practical
              problems. I have 8 years of professional experience in building fault tolerant, high
              performance, scalable distributed systems and GenAI applications.
            </p>

            <p>
              Currently, I am working as a Senior Software Engineer at Klarity Intelligence, Inc. My
              interests include:
            </p>

            {/* With software development, there is always something new to discover. I am passionate about solving new challenges and learning new things. */}

            {/* When I'm not in front of a computer screen, I'm probably hiking, surfing, skiing or crossing off another item on my bucket list. */}
          </div>

          {/* TODO:  increase font size for interests*/}
          <ul className="interests">
            {interests && interests.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>

          <div>
            <p>
              I'm a nomad Software Engineer, always searching for the next challenge; no task is too
              scary nor too difficult.
            </p>
            <p>
              If you believe that my expertise aligns with your goals, or if you'd like to discuss
              potential collaborations, please don't hesitate to reach out. I'm always eager to
              connect with fellow enthusiasts and professionals.
            </p>
          </div>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
